var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuqiang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 653",
    d: "M13.0341 0.75L1.81958 1.88897V14.111L12.815 15.25L15.1806 14.5053V1.66994L13.0341 0.75Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 654",
    d: "M1.81958 7.93427H13.4721",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 655",
    d: "M6.98877 1.45093V14.6805",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 656",
    d: "M15.1586 1.69184L13.0339 0.75V15.2062L15.1586 14.5272V1.69184Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuqiang);
export default __webpack_public_path__ + "static/media/muqiang.4345ad3fcb0ea85f666c3c85ca6f5fdb.svg";
export { ForwardRef as ReactComponent };